module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "pg19"
    }
  }, [_vm._v("5")])]), _c('a', {
    attrs: {
      "id": "pg19"
    }
  }, [_c('p', {
    staticClass: "chaptit"
  }, [_c('i', [_vm._v("City of Atlanta")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The "), _c('i', [_vm._v("City of Atlanta")]), _vm._v(" was completed in April 1904 by the Delaware River Iron Shipbuilding and Engine Works of Chester, Pennsylvania. The owner was the Ocean SS Company out of Savannah, Georgia. It was a 5,269-ton steam merchant ship with a planned route from New York to Savannah, Georgia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the years, it would be plagued with three misfortunes. It seemed the "), _c('i', [_vm._v("City of Atlanta")]), _vm._v(" was going to be followed by disasters and have an accident every five years. On October 29, 1920, it badly damaged the bow in a collision with the concrete ship "), _c('i', [_vm._v("Cape Fear")]), _vm._v(". The "), _c('i', [_vm._v("Cape Fear")]), _vm._v(" sank in three minutes off Narragansett Bay. On February 10, 1925, the "), _c('i', [_vm._v("City of Atlanta")]), _vm._v(" was involved in another collision with the barge "), _c('i', [_vm._v("Juniper")]), _vm._v(". The barge also sank, off York Spit, Baltimore. On May 14, 1930, "), _c('i', [_vm._v("Atlanta")]), _vm._v(" collided with another vessel, this time with the schooner "), _c('i', [_vm._v("Azua")]), _vm._v(", which sank southeast of Barnegat, New Jersey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In January 1942, the "), _c('i', [_vm._v("City of Atlanta")]), _vm._v(" left New York for Savannah, Georgia, carrying three thousand tons of food and a few passengers. The captain was staying as close to the coastline as he could and keeping the navigational lights dim, trying to avoid U-boats. Despite his efforts, there was a U-boat patrolling the waters of the North Carolina coast. The U-boat spotted the "), _c('i', [_vm._v("City of Atlanta")]), _vm._v(" hugging the coast and started tracking the steamship. The U-boat followed the "), _c('i', [_vm._v("City of Atlanta")]), _vm._v(" for almost three hours before coming within 250 meters of the ship.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pg19"
    }
  }), _c('a', {
    attrs: {
      "id": "pg20"
    }
  }, [_vm._v("At 9:09 a.m. on January 19, 1942, the "), _c('i', [_vm._v("City of Atlanta")]), _vm._v(" was hit by a torpedo from the U-boat, "), _c('i', [_vm._v("U-123")]), _vm._v(", eight to ten miles off the coast. The torpedo struck the waterline with a massive explosion, and the ship sank in about ten minutes—before any of the lifeboats could be lowered. All the people on the "), _c('i', [_vm._v("City of Atlanta")]), _vm._v(" perished, except for one officer and two men who survived by clinging to the wreckage. They were picked up by the "), _c('i', [_vm._v("Seatrain, Texas")]), _vm._v(", after about six hours.")])]), _c('a', {
    attrs: {
      "id": "pg20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('i', [_vm._v("City of Atlanta")]), _vm._v(" is under about ninety feet of water east of Buxton, North Carolina. Today, the site mostly consists of a large debris field.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afbd520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter05.vue
// module id = 87
// module chunks = 0